import { render } from "./HomeFeatureLeft.vue?vue&type=template&id=21c58db4&scoped=true"
import script from "./HomeFeatureLeft.vue?vue&type=script&lang=js"
export * from "./HomeFeatureLeft.vue?vue&type=script&lang=js"

import "./HomeFeatureLeft.vue?vue&type=style&index=0&id=21c58db4&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-21c58db4"

export default script